<template>
    <v-app>
        <div class="bg-mesh" />
        <app-confirm-dialog />

        <v-main v-if="$route.meta.layout === 'fullscreen'">
            <router-view />
        </v-main>

        <app-layout v-if="$route.meta.layout === 'menu'" />
    </v-app>
</template>

<script>
export default {
    name: 'App',
    components: {
        AppLayout: () => import('./layouts/AppLayout.vue'),
    },
    computed: {
        user(){
            return this.$store.state.currentUser
        }
    },
    methods: {
        async load() {
            if (this.user?.role === 'admin') {
                await this.$store.dispatch('users/load')
            }
        }
    },
    watch: {
        'user': {
            handler: 'load',
            immediate: true,
        }
    },
}
</script>
